import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useApiUrls from "../../useApiUrls";

const AddThirdPartyHtml = () => {
  const navigate = useNavigate();
  const { getUrlByOperation } = useApiUrls();

  const [formData, setFormData] = useState({
    name: "",
    url: "",
    remark: "",
    active: true
  });

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");
  const [loading, setLoading] = useState(false);

  const token = getCookie("token") || getCookie("authToken") || "";
  const userid = getCookie("userid") || getCookie("userId") || "1";

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value === "true" ? true : value === "false" ? false : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      setMessage("Please enter a Name");
      setMessageType("danger");
      return;
    }

    if (!formData.url.trim()) {
      setMessage("Please enter a URL");
      setMessageType("danger");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const insertUrl = getUrlByOperation("ThirdPartyHtmlInsert") || "https://api.dqr-display-tms.bonrix.in/api/ThirdPartyHtmlOperation/Insert";
      const payload = {
        name: formData.name,
        url: formData.url,
        remark: formData.remark,
        active: Boolean(formData.active)
      };

      const response = await axios.post(
        insertUrl,
        payload,
        {
          headers: {
            "accept": "text/plain",
            "X-Authorization": token,
            "UserId": userid,
            "Content-Type": "application/json-patch+json"
          }
        }
      );

      if (response.data && (response.data.isresponse || response.data.responsestatus === "SUCCESS")) {
        setMessage("Third Party HTML added successfully!");
        setMessageType("success");
        setTimeout(() => {
          navigate("/thirdparty-html");
        }, 1500);
      } else {
        setMessage(response.data?.errormsg || "Failed to add Third Party HTML");
        setMessageType("danger");
      }
    } catch (error) {
      console.error("Error adding Third Party HTML:", error);
      setMessage(error.response?.data?.errormsg || error.message || "Failed to add Third Party HTML");
      setMessageType("danger");
      if (error.message === "relogin token expire" || error.response?.status === 401) {
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center">
                <h1>Add Third Party HTML</h1>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/thirdparty-html")}
                >
                  <i className="fas fa-arrow-left mr-1"></i> Back to List
                </button>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">New Entry Details</h3>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name *</label>
                              <input
                                type="text"
                                className="form-control"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter name"
                                required
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>URL *</label>
                              <input
                                type="text"
                                className="form-control"
                                name="url"
                                value={formData.url}
                                onChange={handleChange}
                                placeholder="https://example.com/widget"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <textarea
                                className="form-control"
                                name="remark"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter remark or description"
                                rows={3}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Status</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Inactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer mt-3">
                          <button
                            type="submit"
                            className="btn btn-info mr-2"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                Saving...
                              </>
                            ) : (
                              "Add Third Party HTML"
                            )}
                          </button>
                          <button
                            type="button"
                            className="btn btn-default"
                            onClick={() => navigate("/thirdparty-html")}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && (
        <div style={{ position: "fixed", top: "20px", right: "20px", width: "300px", zIndex: "9999" }}>
          <div className={`alert alert-${messageType} alert-dismissible fade show`} role="alert">
            {message}
            <button type="button" className="close" onClick={() => setMessage("")}>
              <span>&times;</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AddThirdPartyHtml;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}
